export default {
  REPORTS: `Reports`,
  REPORT_LIST: `Report list`,
  REQUESTED_REPORT: `See requested reports`,
  REQUEST_REPORT_DESCRIPTION: `See and export customizable reports. Select report type and filters according to your needs.`,
  EXPORT: `Export`,
  REQUEST_NEW_REPORT: `Request New Report`,
  REQUEST_REPORT_CARD: {
    TITLE: `Report request`
  },
  SELECT_REPORT: `Select a report to generate`,
  EXCEL: `Excel`,
  CSV: `CSV`,
  EMPLOYEE_NUMBER: `Employee number`,
  FULL_NAME: `Name`,
  DEPARTMENTS: `Departments`,
  DEPARTMENT: `Department`,
  POSITION: `Position`,
  START: `Start`,
  END: `End`,
  ATTRIBUTES: `Attributes`,
  SELECT_DATE_RANGE: `Please select date range`,
  SELECT_ONE_GROUPING: `Select at least one grouping.`,
  NO_REPORTS: `No reports are currently active, please ask your admin to activate them, if you are the admin click here to view the relevant settings card.`,
  ATTENDANCE_REPORT: {
    TITLE: `Attendance`,
    SUMMARY: `Allows to see the amount of attendance requests by employee, position and/or project.`,
    REPORT_NAME: `attendance_report`,
    GROUP_BY_USER: `Group by user`,
    GROUP_BY_POSITION: `Group by position`,
    GROUP_BY_PROJECT: `Group by project`,
    DESCRIPTION: `Description`,
    NB_REQUEST: `Number of attendance requests`,
    NO_PROJECT: `No project`,
    NO_POSITION: `No position`,
    NO_USER: `No user`,
    FULL_NAME: `Name`,
    POSITION_NAME: `Position`,
    PROJECT_NAME: `Project`
  },
  ATTENDANCE_RAW_REPORT: {
    TITLE: `Attendance raw export`,
    SUMMARY: `Allows to export the attendance requests in a raw format.`
  },
  USER_ATTRIBUTES_REPORT: {
    TITLE: `Attributes`,
    SUMMARY: `Allows to see the users attributes.`,
    REPORT_NAME: `attributes_report`,
    NAME: `Name`,
    ATTRIBUTES: `Attributes`
  },
  EXPIRING_ATTRIBUTES_REPORT: {
    TITLE: `Expiring attributes`,
    SUMMARY: `Allows to see and export the expiring attributes providing a date range.`,
    REPORT_NAME: `expiring_attributes_report_{{rangeStart}}-{{rangeEnd}}`,
    NAME: `Name`,
    ATTRIBUTE: `Attribute`,
    EXPIRATIONDATE: `Expiration date`,
    REMINDERS: `Reminders`,
    RANGE: {
      LABEL: `Date range`,
      DESCRIPTION: ``
    }
  },
  PAY_REPORT_CONFIRMATION_MODAL: {
    TITLE: `Confirm Export`,
    SUMMARY: `Are you sure you want to export the report with these parameters?`
  },
  CONTACT_ACCEPTATION_REFUSAL_REPORT: {
    TITLE: `Contact lists acceptation/refusal`,
    SUMMARY: `Allows to see and export a list of the amount of shift acceptation/refusal for each employees`,
    REPORT_NAME: `contact_list_acceptation_refusal_report`,
    ATTRIBUTES: `Attributes`,
    ACCEPTATION_REFUSAL: `Acceptance/Refusal`,
    ACCEPTATION: `<0>Accepted:</0> <1>{{count}}</1>`,
    ACCEPTATION_other: `<0>Accepted:</0> <1>{{count}}</1>`,
    REFUSAL: `<0>Refused:</0> <1>{{count}}</1>`,
    REFUSAL_other: `<0>Refused:</0> <1>{{count}}</1>`,
    ACCEPTED: `Accepted`,
    REFUSED: `Refused`,
    DEPARTMENTS: `Departments`,
    ACCEPTED_DATES: `Acceptation dates`,
    REFUSED_DATES: `Refusal dates`
  },
  DAILY_SUMMARY_REPORT: {
    TITLE: `Daily summary`,
    SUMMARY: `Allows to see and export a report of attendance and shift statistics`,
    REPORT_NAME: `daily_summary_report`,
    DATE: `Date`,
    POSITION: `Position`,
    DEPARTMENTS: `Departments`,
    NUMBER_ABSENT: `Absent`,
    NUMBER_EARLY_OUT: `Early out`,
    NUMBER_LATE: `Late`,
    NUMBER_VARIABLE_END_TIME: `Variable end time`,
    NUMBER_OVERTIME_SHIFT: `Overtime shift`,
    NUMBER_REPLACEMENTS: `Replacements`,
    NUMBER_SHIFTS: `Shifts`,
    NUMBER_UNASSIGNED_SHIFTS: `Unassigned shifts`,
    TOTAL_HOURS: `Total hours`,
    GROUP_BY_POSITIONS: `Group by position`,
    REMOVE_ROWS_WITHOUT_DATA: `Remove rows without data statistics`
  },
  SCHEDULE_ANALYSIS_REPORT: {
    TITLE: `Schedule Analysis`,
    SUMMARY: `Allows to analyze number of shifts, hours worked and paid as well as schedule cost.`,
    REPORT_NAME: `schedule_analysis_report_{{rangeStart}}-{{rangeEnd}}`,
    GROUPEMPLOYEE: `Group by employee`,
    GROUPPOSITION: `Group by position`,
    GROUPDEPARTMENT: `Group by department`,
    GROUPPROJECT: `Group by project`,
    GROUPTEAM: `Group by team`,
    GROUPTIME: `Group by shift start`,
    GROUPDATE: `Group by shift date`,
    NUMBER_OF_SHIFTS: `Number of shifts`,
    PLANNED_HOURS: `Scheduled hours`,
    PAID_HOURS: `Paid hours`,
    PLANNED_COST: `Planned cost`,
    PAID_COST: `Paid cost`,
    PROJECT: `Project`,
    TEAM: `Team`,
    SHIFT_DATE: `Start date`,
    SHIFT_TIME: `Start time`,
    TOTALS: `Totals`,
    TOTAL: `Total`,
    PAID: `Paid`,
    PLANNED: `Planned`
  },
  PAY_EXPORT_NETHRIS_REPORT: {
    TITLE: `Pay export (EmployeurD/Nethris)`,
    SUMMARY: ``,
    AMOUNT: `Quantity`,
    WEEK: `Week`,
    RANGE: `Date range to export`,
    PERIOD_END: `End date of the pay period`,
    PERIOD: `Week number`,
    COMPANY: `Company`,
    EMPLOYEEID: `Employee no.`,
    POSITION: `Position`,
    FIRSTNAME: `First name`,
    LASTNAME: `Last name`,
    EMPLOYEENAME: `Employee name`,
    STATEMENTNUMBER: `Record no.`,
    DIV: `Div.`,
    SERV: `Serv.`,
    DEPT: `Dept.`,
    SDEPT: `S.-dept.`,
    PERIODENDDATE: `Period`,
    WORKIDS1: `Work id -S1`,
    WORKIDS2: `Work id -S2`,
    WORKIDS: `Work ids`,
    REMOVE_CARD_WITH_MISSING_INFO: `Remove card(s) that have missing codes equivalences`,
    POSITIONCODES: `Position codes`,
    WORKCODES: `Work codes`,
    POSITIONCODES_DETAIL: `<0>co:</0>{{ companyId }} <0>div:</0>{{ division }} <0>dep:</0>{{ department }} <0>sdep:</0>{{ subDepartment }} <0>serv:</0>{{ service }} <0>rate:</0>{{hourlyRate}}`
  },
  PAY_EXPORT_APOGEE_REPORT: {
    TITLE: `Pay export (Apogée)`,
    SUMMARY: ``,
    RANGE: {
      LABEL: `Date range to export`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  PAY_EXPORT_GENERIC_REPORT: {
    TITLE: `Pay export`,
    SUMMARY: ``,
    SHEET_NAME: `Pay`,
    REPORT_NAME_ALL: `pay_report_({{rangeStart}}-{{rangeEnd}})`,
    REPORT_NAME_REGULAR: `pay_report_regular-time ({{rangeStart}} - {{rangeEnd}})`,
    REPORT_NAME_OVERTIME: `pay_report_overtime ({{rangeStart}} - {{rangeEnd}})`,
    REPORT_NAME_OTHER: `pay_report_other ({{rangeStart}} - {{rangeEnd}})`,
    REPORT_NAME_TIMEOFF_AND_ATTENDANCE: `pay_report_vacation_and_attendance_({{rangeStart}}-{{rangeEnd}})`,
    RANGE: { LABEL: `Date range to export`, DESCRIPTION: `` },
    POSITION: `Position`,
    PROJECT: `Project`,
    DEPARTMENT: `Department`,
    INFORMATION: `Information`,
    SHIFT: `{{count}} shift`,
    SHIFT_other: `{{count}} shifts`,
    ERROR: `{{count}} Punch card error`,
    ERROR_other: `{{count}} Punch card errors`,
    TRANSFER: `{{count}} transfer`,
    TRANSFER_other: `{{count}} transfers`,
    NEED_ACTION: `{{count}} punch card requires attention, please go verify and approve them in the punch card list interface.`,
    NEED_ACTION_other: `{{count}} punch cards require attention, please go verify and approve them in the punch card list interface.`,
    NO_SHIFT: `{{count}} punch card missing from this report.`,
    NO_SHIFT_other: `{{count}} punch cards missing from this report.`,
    NO_SHIFT_DESC: `Punch cards without an associated shift cannot be included in the Pay report. To fix this issue, add the missing shift(s) in the Punches module.`,
    USER: `User`,
    EMPLOYEENUMBER: `Employee number`,
    EARNINGCODE: `Earning code`,
    AMOUNT: `Amount`,
    EARNINGCODE_AMOUNT: `Earning code & Amount`,
    EMPLOYEEPAY: `Pay rates`,
    REGULAR_PAY: `Regular: {{ regular }}`,
    OVERTIME_PAY: `Overtime: {{ overtime }}`,
    REQUEST_TYPE: `Reason or vacation type`,
    ALL_FIELDS: `Export complete report`,
    BY_POSITION_PROJECT: `Export report grouped by position and project`,
    BY_EARNING_CODE: `Export report grouped by earning Code`,
    ALL_DATA: `All data`,
    REGULAR_TIME: `Regular time only`,
    OVERTIME: `Overtime only`,
    OTHER: `Other wage premiums`,
    PROJECT_TAGS: `Project tags`,
    DATE: `Date`
  },
  TIME_OFF_AND_ATTENDANCE_REPORT: {
    TITLE: `Time off and Attendance pay report`,
    SUMMARY: ``
  },
  PROJECT_OWNER_WORKLOAD_REPORT: {
    TITLE: `Project owner workload`,
    SUMMARY: `Allows to see and export all projects, their owners, and their staffing requirements on the selected dates.`,
    REPORT_NAME: `project_owner_workload_report`,
    PROJECT_OWNERS: `Project owners`,
    PROJECT_NAME: `Project`
  },
  PROJECT_USER_STATUS_REPORT: {
    TITLE: `Project user status`,
    SUMMARY: `Allows to see and export the status of employees as it relates to a project they belong to.`,
    REPORT_NAME: `project_user_status_report`,
    DEPARTMENTS: `Departments`,
    OCCUPATIONS: `Occupations`,
    ATTRIBUTES: `Attributes`,
    PROJECT_LOCKED: `Locked`,
    PROJECT_BLOCKED: `Blocked`,
    PROJECT_PREFERRED: `Preferred`,
    PRIMARY_OCCUPATIONS: `Primary occupation`,
    SECONDARY_OCCUPATIONS: `Secondary occupation`,
    RESTRICTIONS: `Restrictions`,
    SKILLS: `Skills`,
    REQUIREMENTS: `Requirements`
  },
  SCHEDULE_CAPACITY_DEBUG_REPORT: {
    TITLE: `Schedule capacity debug`,
    SUMMARY: `Allows exporting of a single date and position for schedule capacity, as well as exporting the names of the users that are counted.`,
    REPORT_NAME: `schedule capacity_debug_report`,
    OCCUPATIONS: `Occupations`,
    DATE: `Date`,
    IS_ELIGIBLE: `Is eligible`,
    UNAVAILABLE_ALL_DAY: `Unavailable`,
    ON_TIME_OFF: `On time off`,
    ON_LEAVE: `On leave`,
    TOTAL_PRIMARY: `<0>Total primary:</0> {{value}}`,
    TOTAL_SECONDARY: `<0>Total secondary:</0> {{value}}`,
    TOTAL: `<0>Total:</0> {{num}} / {{total}}`,
    PRIMARY_OCCUPATIONS: `Primary occupation`,
    SECONDARY_OCCUPATIONS: `Secondary occupation`
  },
  SCHEDULE_EXPORT_REPORT: {
    TITLE: `Schedule export`,
    SUMMARY: `Allows to see and export all shifts for a specific range.`,
    REPORT_NAME: `schedule_export_report_{{rangeStart}}-{{rangeEnd}}`,
    EMPLOYEE_NUMBER: `Employee number`,
    START: `Start`,
    STARTDATE: `Start date`,
    END: `End`,
    ENDDATE: `End date`,
    EMPLOYEENUMBER: `Employee number`,
    FIRSTNAME: `First name`,
    LASTNAME: `Last name`,
    PRIMARYOCCUPATION: `Primary occupation`,
    POSITIONCODE: `Position code`,
    POSITIONNAME: `Position`,
    COMMENT: `Comment`,
    STATUS: `Status`,
    ARRIVALTIME: `Arrival time`,
    DEPARTURETIME: `Departure time`,
    PROJECTNAME: `Project`,
    PROJECTCODE: `Project code`,
    PROJECTOWNERS: `Project owners`,
    LOCKEDTOPROJECT: `Locked to projects`,
    BLOCKEDFROMPROJECT: `Blocked from projects`,
    PREFERREDONPROJECT: `Preferred on projects`,
    TEAMNAME: `Team`,
    CLIENTTAGS: `Client tags`,
    IS_VARIABLE_END_TIME: `Variable end time`,
    ISIRREPLACEABLE: `Should not be replaced`,
    NEEDSREPLACEMENT: `Needs to be replaced`,
    COVEREDOTHERUNIT: `Covered by another unit`,
    ISOVERTIME: `Overtime`,
    ISONCALL: `On call`,
    NOEMPLOYEEAVAILABLE: `No employee available`,
    HASSPECIFICREQUIREMENTS: `Has specific requirements`,
    LOCATIONTAGS: `Location tags`,
    REGIONALTAGS: `Regional tags`,
    RESOURCETAGS: `Resource tags`,
    CUSTOMTAGS: 'Custom tags',
    USERDEPARTMENTS: `User departments`,
    SHIFTDEPARTMENTS: `Shift departments`,
    TEMPLATE: `Schedule template name`,
    TEMPLATEID: `Schedule template Id`,
    SHIFTID: `Shift Id`
  },
  VACATION_REPORT: {
    TITLE: `Time off`,
    SUMMARY: `Allows to see and export the number of approved time off requests there are per type over a range of dates.`,
    REPORT_NAME: `time_off_report_{{rangeStart}}-{{rangeEnd}}`,
    TYPE: `Type`
  },
  VACATION_RAW_REPORT: {
    TITLE: `Time off raw`,
    SUMMARY: `Allows to export the time off requests in a raw format.`
  },
  AVAILABILITY_REPORT: {
    TITLE: `Availabilities`,
    SUMMARY: `Allows to see and export availability and work preferences for each employee in a selected period.`,
    REPORT_NAME: `availability_report_{{rangeStart}}-{{rangeEnd}}`,
    AVAILABLITIES: `Availabilities`,
    INFORMATION: `Information`,
    ATTRIBUTES: `Attributes: `,
    HIRING_DATA: `Hiring data: `
  },
  REQUESTS: {
    TITLE: `Requested reports`,
    SUMMARY: `Allows to see and export all the requested reports and their statuses.`,
    TYPE: `Type`,
    STATUS: `Status`,
    REQUESTEDAT: `Requested on`,
    FILTERS: `Filters`,
    DATES: `Dates`,
    SCHEDULE_ANALYSIS_REPORT: `Schedule analysis`,
    PENDING: 'pending',
    PROCESSING: 'processing',
    READY: 'ready',
    FAILED: 'failed',
    DELETE_BUTTON: {
      TITLE: 'Delete Report Request',
      SUMMARY: 'Are you sure you want to delete this report request?',
      PRIMARY_ACTION: `Delete the request`
    },
    EMAIL_NOTIFICATION: `Please note that if the generation of the report takes more than one minute, an email notification will be sent to you when it is ready.`
  },
  USER_CONTACT_REPORT: {
    TITLE: `Outbound user contacts`,
    SUMMARY: `Sum of the number of times users have been contacted by the Merinio system during the selected date range.`,
    REPORT_NAME: `outbound_user_contacts_report`,
    CALL_LENGTH: `<0>Call length:</0> {{totalCallLength}}`,
    CONTACT: `<0>Contacted:</0> {{count}}`,
    CONTACT_other: `<0>Contacted:</0> {{count}}`,
    INFORMATION: `Information`,
    NB_BY_PHONE: `Numbers of contacts by phone`,
    NB_BY_PHONE_DESC: `Sum of the number of times users have been contacted by the Merinio system during the selected date range. (Ex.: If a user is contacted once by phone and once later by SMS, this will count as two contacts.)`,
    NB_BY_EMAILS: `Numbers of contacts by emails`,
    NB_BY_EMAILS_DESC: `Sum of the number of contacts made by users via emails, for the selected period.`,
    BY_CALL_LENGTH: `Call length`,
    BY_CALL_LENGTH_DESC: `Sum of the duration of Merinio system phone calls made to users during the selected date range (includes voicemail duration).`,
    ATTRIBUTES: `Attributes`,
    DEPARTMENTS: `Departments`
  },
  CONTACT_AMOUNT_REPORT: {
    TITLE: `Outbound user contacts`,
    SUMMARY: `Sum of the number of times users have been contacted by the Merinio system during the selected date range.`
  },
  CONTACT_CALL_LENGTH_REPORT: {
    TITLE: `Outbound user contacts (Contact by phone)`,
    SUMMARY: `Sum of the duration of Merinio system phone calls made to users during the selected date range (includes voicemail duration).`
  },
  CONTACT_EMAIL_AMOUNT_REPORT: {
    TITLE: `Outbound user contacts (Contact by emails)`,
    SUMMARY: `Sum of the number of contacts made by users via emails, for the selected period.`
  },
  SKYLINE_REPORT: {
    TITLE: `Project scheduling`,
    SUMMARY: `Allows to see and export a summary of shifts per project position and start/end time over a selected period.`,
    REPORT_NAME: `project_scheduling_report_{{rangeStart}}-{{rangeEnd}}`,
    NAME: `Name`,
    CODE: `Code`,
    PROJECT_STATUS: `Status`,
    DEPARTMENT: `Department`,
    POSITION: `Position`,
    CLIENTS: `Clients`,
    LOCATION: `Location`,
    START_TIME: `Start time`,
    LENGTH: `Length`,
    PROJECT_OWNERS: `Project owners`,
    DATES: `Dates`,
    GROUP_DATES: `Group dates in one column`
  },
  QUESTIONNAIRE_RESPONSES: {
    TITLE: `Questionnaire answers`,
    SUMMARY: `Allows to see and export responses from the questionnaires if they are active`,
    CREATED_AT: `Answered at`,
    NOT_ALLOWED_TO_PUNCH: `Prevented from punching`,
    ERROR_TRIGGERED: `Triggered warning`,
    ANSWERS: `Answers`,
    EXPLANATION: `Explanation`,
    REPORT_NAME: 'questionnaire_export_{{rangeStart}}-{{rangeEnd}}',
    PUNCHQUESTIONNAIRE: `Punch questionnaire`,
    DAILYQUESTIONNAIRE: `Daily questionnaire`
  },
  UNSCHEDULED_USERS_REPORT: {
    TITLE: `Unscheduled users`,
    SUMMARY: `Allows to see and export all employees that were not scheduled over a period of time.`,
    REPORT_NAME: `unscheduled_users_report_{{ range }}`,
    FILTERONTIMEOFF: {
      LABEL: `Check time off`,
      DESCRIPTION: `If checked, users on time off will be filtered as well.`
    }
  }
}
